import { PublicPaymentMethodPropertyResponse } from '../api/response/public-payment-method-property.response';
import { PublicPaymentMethodProperty } from '../models/public-payment-method-property';

export const publicPaymentMethodPropertyFromResponse = (
  response: PublicPaymentMethodPropertyResponse,
) => {
  return new PublicPaymentMethodProperty({
    name: response.name,
    code: response.code,
  });
};
